import React from 'react';
import { PHARMACY_COPY, statusLabel } from '../pharmacyCopy';

const copy = PHARMACY_COPY.DISTRIBUTIONS;

export const DISTRIBUTION_STATUSES = ['', 'PENDING', 'PREPARING', 'SHIPPED', 'DELIVERED', 'CANCELLED'];

export const FLOW_STEPS = [
  { id: 'PENDING', label: copy.FLOW_PENDING },
  { id: 'PREPARING', label: copy.FLOW_PREPARING },
  { id: 'SHIPPED', label: copy.FLOW_SHIPPED },
  { id: 'DELIVERED', label: copy.FLOW_DELIVERED }
];

export function distributionStatusClass(status) {
  if (status === 'DELIVERED') return 'cp-status-pill--ok';
  if (status === 'CANCELLED') return 'cp-status-pill--muted';
  if (status === 'SHIPPED') return 'cp-status-pill--info';
  if (status === 'PREPARING') return 'cp-status-pill--warn';
  if (status === 'PENDING') return 'cp-status-pill--muted';
  return 'cp-status-pill--muted';
}

export function nextActionLabel(status) {
  if (status === 'PENDING') return copy.NEXT_PENDING;
  if (status === 'PREPARING') return copy.NEXT_PREPARING;
  if (status === 'SHIPPED') return copy.NEXT_SHIPPED;
  if (status === 'DELIVERED') return copy.NEXT_DELIVERED;
  if (status === 'CANCELLED') return copy.NEXT_CANCELLED;
  return '';
}

function flowIndex(status) {
  if (status === 'CANCELLED') return -1;
  return FLOW_STEPS.findIndex((s) => s.id === status);
}

export function DistributionFlow({ status }) {
  if (status === 'CANCELLED') {
    return (
      <div className="cp-order-flow cp-order-flow--cancelled" aria-label={copy.FLOW_TITLE}>
        <span className="cp-status-pill cp-status-pill--muted">{statusLabel('CANCELLED')}</span>
      </div>
    );
  }
  const active = flowIndex(status);
  return (
    <ol className="cp-order-flow" aria-label={copy.FLOW_TITLE}>
      {FLOW_STEPS.map((step, i) => {
        let state = 'upcoming';
        if (i < active) state = 'done';
        else if (i === active) state = 'current';
        return (
          <li key={step.id} className={`cp-order-flow__step is-${state}`}>
            <span className="cp-order-flow__dot" aria-hidden>
              {state === 'done' ? '✓' : i + 1}
            </span>
            <span className="cp-order-flow__label">{step.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
